import MiniCard from "./MiniCard";
export default MiniCard;


// WEBPACK FOOTER //
// ./src/MiniCard/index.js